import { PUBLIC } from 'router/routes';

const isPrivateRoute = (pathname: string) => !Object.values(PUBLIC).find(({ path }) => path === pathname);

export default isPrivateRoute;
